import * as React from 'react';
import { Track, PointSection, Point, TrackValue, TrackValuePlus } from './styles.js';

const RentalPlanSelectorTrack = ({ isShortVersion , points , handlePointClick , handlePointHover , handlePointKeyDown , pointAccentColors , allPointsHaveAccentColor , isDisabled , hasPlusLabel , currentPointIndex  })=>{
    return /*#__PURE__*/ React.createElement(Track, {
        isShortVersion: isShortVersion,
        role: "radiogroup"
    }, points === null || points === void 0 ? void 0 : points.map((point, index)=>{
         return React.createElement(PointSection, {
            key: point.value,
            onClick: ()=>handlePointClick(point),
            onMouseOver: ()=>handlePointHover(point),
            onFocus: ()=>handlePointHover(point),
            onKeyDown: (e)=>handlePointKeyDown(e, index),
            $isShortVersion: isShortVersion,
            role: "radio",
            "aria-checked": index === currentPointIndex,
            "aria-label": `${point.value}${hasPlusLabel ? "+" : ""} ${point.label}`,
            tabIndex: index === currentPointIndex ? 0 : -1
        }, /*#__PURE__*/ React.createElement(Point, {
            hasAccentColors: Boolean(point === null || point === void 0 ? void 0 : point.hasAccentColors) && !allPointsHaveAccentColor,
            backgroundColor: (pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.backgroundColor) ?? "",
            isShortVersion: isShortVersion,
            isDisabled: isDisabled
        }, /*#__PURE__*/ React.createElement(TrackValue, {
            hasAccentColors: Boolean(point === null || point === void 0 ? void 0 : point.hasAccentColors) && !allPointsHaveAccentColor,
            textColor: (pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.textColor) ?? "",
            isDisabled: isDisabled
        }, point.value, hasPlusLabel && /*#__PURE__*/ React.createElement(TrackValuePlus, null, "+"))));
    }));
};

export { RentalPlanSelectorTrack };
